import styled from '@emotion/styled';
import mediaQuery from '@/lib/styling/mediaQuery';

const SectionContentWrapper = styled('div')({
  display: 'flex',
  [mediaQuery(640)]: {
    flexDirection: 'column',
  },
});

export default SectionContentWrapper;
